import * as React from 'react';

import {Price} from 'shells/billing/price';
import {Card} from 'shells/card/card';
import {colors} from 'shells/colors/colors';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import type {GetInvoicePreview_invoicePreview as InvoicePreview} from 'nutshell-graphql-types';

type Props = {
    invoicePreview: InvoicePreview | null | undefined;
};

export function NextInvoiceDetails(props: Props) {
    if (!props.invoicePreview) {
        return null;
    }

    return (
        <div>
            <Card hasBorder={true} borderColor={colors.success}>
                <div className='flex justify-sb pad-16'>
                    <StackLegacy spacing={16}>
                        <StackLegacy spacing={4}>
                            <Body as='div' isBold={true}>
                                {props.invoicePreview.dueText}
                            </Body>
                            <Body size='small'>{props.invoicePreview.subtitleText}</Body>
                        </StackLegacy>
                    </StackLegacy>
                    <div className='flex align-center'>
                        <Price
                            price={props.invoicePreview.nextInvoiceDisplay}
                            includeDollarSign={false}
                            size='extraLarge'
                            isBold={true}
                        />
                    </div>
                </div>
            </Card>
        </div>
    );
}
